export type TisaProduct = 'auth' | 'umpire' | 'wicket' | 'brisk' | 'gateway';
